import { create } from '@github/webauthn-json'

export const registerWebAuthn = data =>
  create({ publicKey: data.registrationData.credentialCreationOptions }).then(
    signedData => Promise.resolve(signedData),
    error => {
      return Promise.reject(new Error(error))
    }
  )
